// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__IF0fK","card":"Cards_card__3bRNS","confirmed":"Cards_confirmed__3kFky","recovered":"Cards_recovered__BLx26","deaths":"Cards_deaths__2crno"};